<template>
  <div class="home">
    <div class="modules" v-if="modules.length">
      <div v-for="m in modules" class="module" :class="{is_heading: m.type == 1,
                                                        is_text: m.type == 2,
                                                        is_image: m.type == 3,
                                                        is_countdown: m.type == 4,
                                                        is_animation: m.type == 5,
                                                        is_railroad: m.type == 6}" :key="m.id">
        <div class="m_heading" v-if="m.type == 1">
          <div>
            {{m.heading}}
          </div>
          <div class="language_selector">
            <template v-if="language == 'eng'">
              <div class="active">English</div>
              <div class="divider"></div>
              <div class="inactive"><router-link :to="{path:'/nor'}">Norsk</router-link></div>
            </template>
            <template v-else>
              <div class="active">Norsk</div>
              <div class="divider"></div>
              <div class="inactive"><router-link :to="{path:'/eng'}">English</router-link></div>
            </template>
          </div>
        </div>
        <div class="m_text" v-if="m.type == 2" v-html="m.text"></div>
        <div class="m_image" v-if="m.type == 3"><img :src="m.imageSrc"></div>
        <div class="m_countdown" v-if="m.type == 4">
          <countdown />
        </div>
        <div class="m_animation" v-if="m.type == 5">
          <animation />
        </div>
        <div class="m_railroad" v-if="m.type == 6">
          <railroad />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../api';
  import Countdown from './Countdown';
  import Animation from './Animation';
  import Railroad from './Railroad';

  export default {
    name: 'Home',
    components: {Countdown, Animation, Railroad},

    data () {
      return {
        language: this.languageFromRoute(),
        colors: null,
        legend: null,
        mapData: null,
        railroadEvents: null,
        modules: [],
      };
    },

    async mounted () {
      await this.getData();
    },

    watch: {
      $route() {
        this.language = this.languageFromRoute();
        this.getData();
      },
    },

    methods: {
      languageFromRoute() {
        return this.$route.params.language == 'eng' ? 'eng' : 'nor';
      },

      async getData () {
        let response = await API().post('/minisite', {
          mode: 'getMiniSiteContentByLanguage',
          language: this.language,
        });
        if (response.status == 200 && response.data.result.success) {
          this.colors = response.data.result.record.colors;
          this.legend = response.data.result.record.legend;
          this.mapData = response.data.result.record.mapData;
          this.railroadEvents = response.data.result.record.railroadEvents;
          this.modules = response.data.result.record.modules;
        } else {
          this.modules = [];
        }
      },
    }
  }
</script>

<style lang="less">
  @scene_bg_color: #000B41;
  @nav_bg_color: #2D2D87;

  .home {
    position: relative;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    background-color: @scene_bg_color;
    font-size: 18px;
    color: #fff;
    /*padding: 0px 60px;*/
    /*box-sizing: border-box;*/
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    .modules {
      width: 100%;
    }

    .module {
      position: relative;
      box-sizing: border-box;
      &.is_heading {
        padding: 75px 35px 5px 35px;
        font-size: 57px;
        font-weight: 300;
        line-height: 1;
      }
      &.is_text {
        padding: 25px 35px 25px 35px;
        p {
          margin-top: 0;
          margin-bottom: 0;
        }
      }
      &.is_image {}
      &.is_countdown {}
      &.is_animation {}
      &.is_railroad {}
    }

    .language_selector {
      font-size: 18px;
      font-weight: normal;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      height: 1em;
      a {
        color: #fff;
      }
      .active {
        font-weight: 300;
      }
      .inactive {

      }
      .divider {
        margin: 0 8px;
        border-right: 1px solid #fff;
      }
    }

    .m_heading {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
    .m_text {
      a {
        color: #fff;
      }
    }
    .m_image {
      img {
        width: 100%;
      }
    }
    .m_countdown {}
    .m_animation {}
    .m_railroad {}

  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue